export default {
      id: "mobile-rect-usage",
      viewBox: "0 0 13 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#mobile-rect",
      toString: function () {
        return this.url;
      }
    }